/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Botica API
 * API for the Botica professional network for Venezuelan pharmacists
 * OpenAPI spec version: v1
 */
import type {
  CredentialResponse,
  SubmitCredentialRequest,
  UploadDocumentRequest
} from '../boticaAPI.schemas';

import { axiosInstance } from '../../axiosInstance';



  export const getCredentials = () => {
const getApiCredentials = (

 ) => {
      return axiosInstance<CredentialResponse>(
      {url: `/api/Credentials`, method: 'GET'
    },
      );
    }
  const postApiCredentials = (
    submitCredentialRequest: SubmitCredentialRequest,
 ) => {
      return axiosInstance<CredentialResponse>(
      {url: `/api/Credentials`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitCredentialRequest
    },
      );
    }
  const postApiCredentialsUploadDocument = (
    uploadDocumentRequest: UploadDocumentRequest,
 ) => {
      return axiosInstance<CredentialResponse>(
      {url: `/api/Credentials/upload-document`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: uploadDocumentRequest
    },
      );
    }
  const getApiCredentialsCredentialIdDocument = (
    credentialId: string,
 ) => {
      return axiosInstance<Blob>(
      {url: `/api/Credentials/${credentialId}/document`, method: 'GET',
        responseType: 'blob'
    },
      );
    }
  return {getApiCredentials,postApiCredentials,postApiCredentialsUploadDocument,getApiCredentialsCredentialIdDocument}};
export type GetApiCredentialsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCredentials>['getApiCredentials']>>>
export type PostApiCredentialsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCredentials>['postApiCredentials']>>>
export type PostApiCredentialsUploadDocumentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCredentials>['postApiCredentialsUploadDocument']>>>
export type GetApiCredentialsCredentialIdDocumentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCredentials>['getApiCredentialsCredentialIdDocument']>>>
